const Colours = {
  WHITE: "white",
  BLACK: "black",
};

export default Colours;
